import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import LoadingOverlay from './LoadingOverlay';

const WELDING_LOG_DELAY_QUERY = gql`
  query StatsWeldingLogDelay {
    weldingLogDelay: stats_welding_log_delay {
      projects {
        id
        name
      }
      users {
        userId: user_id
        firstName: first_name
        lastName: last_name
        projectDelays: project_delays
      }
    }
  }
`;

class WeldingLogDelayChart extends Component {
  render() {
    return (
      <Query query={WELDING_LOG_DELAY_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>Welding Log Delay - Top 10 (avg delay days, last 90 days)</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '150px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && (() => {
                const { projects, users } = data.weldingLogDelay;
                return (
                  <Table size="sm" responsive>
                    <thead>
                      <tr>
                        <th>Name</th>
                        {projects.map((project, idx) => (
                          <th key={idx} className="text-center">{project.name}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user, idx) => {
                        const delays = JSON.parse(user.projectDelays);
                        return (
                          <tr key={idx}>
                            <td>{user.firstName} {user.lastName}</td>
                            {projects.map((project, pIdx) => (
                              <td key={pIdx} className="text-center">
                                {delays[project.id] || 0}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                );
              })()}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default WeldingLogDelayChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/WeldingLogDelayChart.js